import { createIcon } from '../icon'
import DayDeliveryIcon from '../svg/DayDeliveryIcon'

export const DayDeliveryIconDefault = createIcon(DayDeliveryIcon)
